(function () {
  if (window.__tpowerShopifySiteLoaded) return;
  window.__tpowerShopifySiteLoaded = true;

  let addressLocateTimer = null;
  let googleMapsLoaderPromise = null;

  function cleanPhone(value) {
    return value.replace(/[^\d+]/g, "");
  }

  function isValidEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value);
  }

  function isValidPhone(value) {
    const cleaned = cleanPhone(value);
    const digits = cleaned.replace(/\D/g, "");
    return digits.length >= 8 && digits.length <= 15;
  }

  function fieldContainer(field) {
    return field.closest(".field") || field.parentElement;
  }

  function setFieldError(field, message) {
    const container = fieldContainer(field);
    const error = container.querySelector(".field-error");
    container.classList.toggle("invalid", Boolean(message));
    if (error) error.textContent = message || "";
  }

  function showStatus(form, type, message) {
    const status = form.querySelector(".form-status");
    if (!status) return;
    status.className = "form-status show " + type;
    status.innerHTML = message;
  }

  function clearStatus(form) {
    const status = form.querySelector(".form-status");
    if (!status) return;
    status.className = "form-status";
    status.innerHTML = "";
  }

  function closeSuccessModal(modal) {
    if (modal) modal.remove();
  }

  function showSuccessModal(form, ref, label) {
    const root = form.closest(".tpower-shopify-page") || document.body;
    root.querySelectorAll("[data-success-modal]").forEach(closeSuccessModal);

    const titleText = form.dataset.successTitle || "Submitted successfully.";
    const template = form.dataset.successMessage || "T-Power will review this {business_label} and follow up using the contact details provided.";
    const messageText = template
      .replace(/\{reference\}/g, ref)
      .replace(/\{business_label\}/g, label);
    const referenceLabel = form.dataset.successReferenceLabel || "Reference:";
    const buttonText = form.dataset.successButtonLabel || "OK";

    const overlay = document.createElement("div");
    overlay.className = "success-modal";
    overlay.setAttribute("data-success-modal", "");
    overlay.setAttribute("role", "dialog");
    overlay.setAttribute("aria-modal", "true");

    const panel = document.createElement("div");
    panel.className = "success-modal-panel";

    const title = document.createElement("h3");
    title.textContent = titleText;

    const referenceNode = document.createElement("p");
    referenceNode.className = "success-modal-ref";
    referenceNode.textContent = referenceLabel + " " + ref;

    const message = document.createElement("p");
    message.className = "success-modal-message";
    message.textContent = messageText;

    const button = document.createElement("button");
    button.className = "btn";
    button.type = "button";
    button.setAttribute("data-success-modal-close", "");
    button.textContent = buttonText;

    panel.appendChild(title);
    panel.appendChild(referenceNode);
    panel.appendChild(message);
    panel.appendChild(button);
    overlay.appendChild(panel);
    root.appendChild(overlay);
    button.focus();
  }

  function updateUploadCard(input) {
    const card = input.closest(".upload-card");
    if (!card) return;
    const meta = card.querySelector("[data-upload-meta]");
    const file = input.files && input.files[0];
    card.classList.toggle("has-file", Boolean(file));
    if (meta) meta.textContent = file ? file.name : meta.dataset.empty || "No file selected";
  }

  function setInterestSummary(titles) {
    const interestedSites = document.querySelector("[data-interested-sites]");
    const interestedValue = document.querySelector("[data-interested-sites-value]");
    const interestedLabel = document.querySelector("[data-interested-sites-label]");
    if (!interestedSites || !interestedValue || !interestedLabel) return;

    const cleanTitles = (titles || []).map(value => String(value || "").trim()).filter(Boolean);
    const emptyLabel = interestedSites.dataset.emptyLabel || "Select one or more sites";

    if (!cleanTitles.length) {
      interestedValue.value = "";
      interestedLabel.textContent = emptyLabel;
      setFieldError(interestedValue, "This field is required.");
      return;
    }

    interestedValue.value = cleanTitles.join(" | ");
    interestedLabel.textContent = cleanTitles.join(", ");
    setFieldError(interestedValue, "");
  }

  function ensureInterestOptions() {
    const interestedSites = document.querySelector("[data-interested-sites]");
    const menu = interestedSites && interestedSites.querySelector("[data-interested-sites-menu]");
    const cards = Array.from(document.querySelectorAll("[data-site-card]"));
    if (!interestedSites || !menu || !cards.length) return;

    if (!menu.querySelector("[data-interested-site-option]")) {
      cards.forEach((card, index) => {
        const title = String(card.dataset.title || "").trim();
        if (!title) return;
        const option = document.createElement("label");
        option.className = "multi-option";
        const checkbox = document.createElement("input");
        checkbox.type = "checkbox";
        checkbox.value = title;
        checkbox.setAttribute("data-interested-site-option", "");
        if (index === 0) checkbox.checked = true;
        const text = document.createElement("span");
        text.textContent = title;
        option.appendChild(checkbox);
        option.appendChild(text);
        menu.appendChild(option);
      });
    }

    const activeCard = document.querySelector("[data-site-card].active") || cards[0];
    if (activeCard) {
      const activeTitle = String(activeCard.dataset.title || "").trim();
      if (activeTitle) {
        const labels = [activeTitle];
        const checkedInputs = Array.from(menu.querySelectorAll("[data-interested-site-option]")).filter(input => input.checked);
        checkedInputs.forEach(input => {
          const value = String(input.value || "").trim();
          if (value && !labels.includes(value)) labels.push(value);
        });
        const activeInput = Array.from(menu.querySelectorAll("[data-interested-site-option]")).find(input => String(input.value || "").trim() === activeTitle);
        if (activeInput) activeInput.checked = true;
        setInterestSummary(labels);
      }
    }
  }

  function syncInterestSection() {
    positionOpportunityMarkers(document);
    initOpportunityLiveMaps(document);
    ensureInterestOptions();
    const activeCard = document.querySelector("[data-site-card].active") || document.querySelector("[data-site-card]");
    if (activeCard) updateSelectedOpportunity(activeCard);
  }

  function updatePlaceholderSelect(select) {
    if (!select || !select.matches("[data-placeholder-select]")) return;
    select.classList.toggle("is-empty", !select.value);
  }

  function pseudoCoordinates(address) {
    let hash = 0;
    for (let index = 0; index < address.length; index += 1) {
      hash = (hash * 31 + address.charCodeAt(index)) >>> 0;
    }
    const lat = -37.95 + ((hash % 1400) / 10000);
    const lng = 144.85 + (((hash >> 8) % 1600) / 10000);
    const x = 28 + (hash % 44);
    const y = 24 + ((hash >> 5) % 34);
    return {
      lat: lat.toFixed(5),
      lng: lng.toFixed(5),
      x,
      y
    };
  }

  function setAddressMap(input, titleText, metaText, geo) {
    const field = fieldContainer(input);
    const map = field.querySelector("[data-address-map]");
    if (!map) return false;
    const title = map.querySelector("[data-map-title]");
    const meta = map.querySelector("[data-map-meta]");
    const pin = map.querySelector(".map-pin");
    const latInput = field.querySelector("[data-address-latitude]");
    const lngInput = field.querySelector("[data-address-longitude]");

    map.classList.add("located");
    map.hidden = false;
    if (pin) {
      pin.style.left = geo.x + "%";
      pin.style.top = geo.y + "%";
    }
    if (title) title.textContent = titleText;
    if (meta) meta.textContent = metaText;
    if (latInput) latInput.value = geo.lat;
    if (lngInput) lngInput.value = geo.lng;
    setFieldError(input, "");
    return true;
  }

  function locateAddress(input, mode) {
    const address = input.value.trim();
    const field = fieldContainer(input);
    const map = field.querySelector("[data-address-map]");
    if (!map) return false;
    const title = map.querySelector("[data-map-title]");
    const meta = map.querySelector("[data-map-meta]");
    const pin = map.querySelector(".map-pin");

    if (!address) {
      map.classList.remove("located");
      map.hidden = true;
      if (title) title.textContent = "Location confirmation";
      if (meta) meta.textContent = "Submitting this form registers your site interest only. T-Power will verify the address and contact suitable parties to discuss potential opportunities.";
      const latInput = field.querySelector("[data-address-latitude]");
      const lngInput = field.querySelector("[data-address-longitude]");
      if (latInput) latInput.value = "";
      if (lngInput) lngInput.value = "";
      if (mode === "manual") setFieldError(input, "This field is required.");
      return false;
    }

    const geo = pseudoCoordinates(address);
    return setAddressMap(input, address, "Location preview saved. T-Power will verify this address during review.", geo);
  }

  function scheduleAddressLocate(input) {
    window.clearTimeout(addressLocateTimer);
    addressLocateTimer = window.setTimeout(() => locateAddress(input, "auto"), 500);
  }

  function compactParts(parts) {
    return parts.map(value => String(value || "").trim()).filter(Boolean).filter((value, index, list) => list.indexOf(value) === index);
  }

  async function reverseGeocodeAddress(lat, lng) {
    const url = "https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=" + encodeURIComponent(lat) + "&longitude=" + encodeURIComponent(lng) + "&localityLanguage=en";
    const response = await fetch(url, { method: "GET", mode: "cors" });
    if (!response.ok) return "";
    const data = await response.json();
    const address = compactParts([
      data.locality,
      data.city,
      data.principalSubdivision,
      data.postcode,
      data.countryName
    ]).join(", ");
    return address || data.localityInfo && data.localityInfo.administrative && data.localityInfo.administrative[0] && data.localityInfo.administrative[0].name || "";
  }

  function useCurrentLocation(button) {
    const field = button.closest(".field");
    const input = field && field.querySelector("[data-address-input]");
    if (!input) return;

    if (!navigator.geolocation) {
      setFieldError(input, "Current location is not supported by this browser. Please enter the address manually.");
      return;
    }

    const originalText = button.textContent;
    const originalLabel = button.getAttribute("aria-label") || "";
    const hasVisibleText = Boolean(originalText.trim());
    button.disabled = true;
    button.classList.add("is-loading");
    button.setAttribute("aria-label", "Locating current position");
    if (hasVisibleText) button.textContent = "Locating...";

    navigator.geolocation.getCurrentPosition(
      position => {
        const lat = Number(position.coords.latitude).toFixed(5);
        const lng = Number(position.coords.longitude).toFixed(5);
        const geo = {
          lat,
          lng,
          x: 50,
          y: 40
        };
        const existingAddress = input.value.trim();
        setAddressMap(input, existingAddress || "Finding your address...", "Current location detected. Finding the nearest address...", geo);

        reverseGeocodeAddress(lat, lng)
          .then(address => {
            const resolvedAddress = address || existingAddress || "Current location selected";
            if (!existingAddress || existingAddress.indexOf("Current location") === 0) input.value = resolvedAddress;
            setAddressMap(input, resolvedAddress, address ? "Address detected from your current location. Please review or edit it if needed." : "Current location selected. Please review or enter the address manually.", geo);
          })
          .catch(() => {
            const fallbackAddress = existingAddress || "Current location selected";
            if (!existingAddress) input.value = fallbackAddress;
            setAddressMap(input, fallbackAddress, "Current location selected. Please review or enter the address manually.", geo);
          })
          .finally(() => {
            button.disabled = false;
            button.classList.remove("is-loading");
            button.setAttribute("aria-label", originalLabel);
            if (hasVisibleText) button.textContent = originalText;
          });
      },
      () => {
        setFieldError(input, "Location permission was denied or unavailable. Please enter the address manually.");
        button.disabled = false;
        button.classList.remove("is-loading");
        button.setAttribute("aria-label", originalLabel);
        if (hasVisibleText) button.textContent = originalText;
      },
      {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 60000
      }
    );
  }

  function reference(prefix) {
    const now = new Date();
    const y = now.getFullYear();
    const m = String(now.getMonth() + 1).padStart(2, "0");
    const d = String(now.getDate()).padStart(2, "0");
    const rand = String(Math.floor(Math.random() * 900) + 100);
    return prefix + "-" + y + m + d + "-" + rand;
  }

  function validateForm(form) {
    let valid = true;
    const fields = Array.from(form.querySelectorAll("input, select, textarea"));

    fields.forEach(field => setFieldError(field, ""));

    fields.forEach(field => {
      if (field.type === "checkbox") {
        if (field.dataset.required === "true" && !field.checked) {
          setFieldError(field, field.dataset.requiredMessage || "Please confirm before submitting.");
          valid = false;
        }
        return;
      }

      const value = field.value.trim();
      if (field.dataset.required === "true" && !value) {
        setFieldError(field, "This field is required.");
        valid = false;
        return;
      }
      if (value && field.dataset.type === "email" && !isValidEmail(value)) {
        setFieldError(field, "Please enter a valid email address.");
        valid = false;
      }
      if (value && field.dataset.type === "phone" && !isValidPhone(value)) {
        setFieldError(field, "Please enter a valid phone number.");
        valid = false;
      }
    });

    return valid;
  }

  function updateHostStatus(ref) {
    const refNodes = document.querySelectorAll("[data-site-ref]");
    refNodes.forEach(node => { node.textContent = ref; });
    const submittedNodes = document.querySelectorAll("[data-after-submit]");
    submittedNodes.forEach(node => { node.hidden = false; });
  }

  function lockSubmittedForm(form, ref) {
    form.dataset.submitted = "true";
    form.dataset.submittedRef = ref;
    const submitButton = form.querySelector("button[type='submit']");
    if (submitButton) submitButton.disabled = true;
  }

  function setImage(node, url) {
    if (node && url) node.style.setProperty("--site-image", "url('" + url + "')");
  }

  function parseMapCoordinate(value) {
    if (value === null || value === undefined) return null;
    const number = Number(String(value).trim());
    return Number.isFinite(number) ? number : null;
  }

  function clampMarkerPercent(value, min, max) {
    return Math.min(max, Math.max(min, value));
  }

  function googleMapsLink(address, lat, lng) {
    const query = String(address || "").trim() || (String(lat) + "," + String(lng));
    return "https://www.google.com/maps/search/?api=1&query=" + encodeURIComponent(query);
  }

  function loadGoogleMaps(apiKey) {
    if (!apiKey) return Promise.reject(new Error("Missing Google Maps API key."));
    if (window.google && window.google.maps) return Promise.resolve(window.google.maps);
    if (googleMapsLoaderPromise) return googleMapsLoaderPromise;

    googleMapsLoaderPromise = new Promise((resolve, reject) => {
      const callbackName = "__tpowerGoogleMapsReady";
      const existingScript = document.querySelector("script[data-tpower-google-maps]");

      window[callbackName] = () => {
        resolve(window.google && window.google.maps);
      };

      if (existingScript) {
        existingScript.addEventListener("load", () => resolve(window.google && window.google.maps), { once: true });
        existingScript.addEventListener("error", () => reject(new Error("Google Maps failed to load.")), { once: true });
        return;
      }

      const script = document.createElement("script");
      script.src = "https://maps.googleapis.com/maps/api/js?key=" + encodeURIComponent(apiKey) + "&v=weekly&libraries=marker&callback=" + callbackName;
      script.async = true;
      script.defer = true;
      script.setAttribute("data-tpower-google-maps", "true");
      script.onerror = () => reject(new Error("Google Maps failed to load."));
      document.head.appendChild(script);
    });

    return googleMapsLoaderPromise;
  }

  function opportunityCoordinates(card) {
    const lat = parseMapCoordinate(card && card.dataset.latitude);
    const lng = parseMapCoordinate(card && card.dataset.longitude);
    if (lat === null || lng === null) return null;
    return { lat, lng };
  }

  function geocodeOpportunityAddress(geocoder, card) {
    const address = String(card && card.dataset.location || "").trim();
    if (!address) return Promise.resolve(null);

    return new Promise(resolve => {
      geocoder.geocode({ address }, (results, status) => {
        if (status !== "OK" || !results || !results[0] || !results[0].geometry) {
          resolve(null);
          return;
        }

        const location = results[0].geometry.location;
        const position = {
          lat: location.lat(),
          lng: location.lng()
        };
        card.dataset.latitude = String(position.lat);
        card.dataset.longitude = String(position.lng);

        const root = card.closest("#opportunities") || document;
        const marker = root.querySelector("[data-site-marker][data-code='" + CSS.escape(card.dataset.code || "") + "']");
        if (marker) {
          marker.dataset.latitude = String(position.lat);
          marker.dataset.longitude = String(position.lng);
        }

        resolve(position);
      });
    });
  }

  function syncMapLocationPanel(root, card) {
    const panel = root.querySelector("[data-map-location-panel]");
    if (!panel || !card) return;
    const title = panel.querySelector("[data-map-location-title]");
    const address = panel.querySelector("[data-map-location-address]");
    const link = panel.querySelector("[data-map-location-link]");
    const position = opportunityCoordinates(card);

    if (title) title.textContent = card.dataset.title || "Selected project location";
    if (address) address.textContent = card.dataset.location || "Location details are not available.";

    if (link) {
      link.hidden = !position;
      if (position) link.href = googleMapsLink(card.dataset.location, position.lat, position.lng);
    }
  }

  function setGoogleMarkerActive(item, active) {
    if (!item || !item.marker) return;
    if (item.pin) {
      item.pin.background = active ? "#0f6f2e" : "#18a746";
      item.pin.borderColor = active ? "#0f6f2e" : "#18a746";
      return;
    }
    if (item.marker.setIcon) {
      item.marker.setIcon({
        path: window.google.maps.SymbolPath.CIRCLE,
        scale: active ? 9 : 7,
        fillColor: active ? "#0f6f2e" : "#18a746",
        fillOpacity: 1,
        strokeColor: "#ffffff",
        strokeWeight: 2
      });
    }
  }

  function updateGoogleMapSelection(root, code) {
    const state = root && root.__tpowerGoogleMap;
    if (!state) return;
    let selected = null;

    state.markers.forEach(item => {
      const active = item.code === code;
      setGoogleMarkerActive(item, active);
      if (active) selected = item;
    });

    if (selected && state.map) {
      state.map.panTo(selected.position);
    }
  }

  function initOpportunityLiveMaps(scope) {
    const container = scope || document;
    const maps = Array.from(container.querySelectorAll ? container.querySelectorAll("[data-opportunity-map][data-google-maps-key]") : []);
    if (container.matches && container.matches("[data-opportunity-map][data-google-maps-key]")) maps.unshift(container);

    maps.forEach(mapRoot => {
      if (mapRoot.__tpowerGoogleMap) return;
      const canvas = mapRoot.querySelector("[data-google-map-canvas]");
      const apiKey = String(mapRoot.dataset.googleMapsKey || "").trim();
      const root = mapRoot.closest("#opportunities") || document;
      const cards = Array.from(root.querySelectorAll("[data-site-card]"));

      if (!canvas || !apiKey || !cards.length) return;

      loadGoogleMaps(apiKey)
        .then(async mapsApi => {
          if (!mapsApi) return;
          const geocoder = new mapsApi.Geocoder();
          const resolvedSites = await Promise.all(cards.map(async card => {
            const position = opportunityCoordinates(card) || await geocodeOpportunityAddress(geocoder, card);
            return { card, position };
          }));
          const sites = resolvedSites.filter(site => site.position);
          if (!sites.length) return;

          const defaultZoom = Number(mapRoot.dataset.googleMapZoom || 13) || 13;
          const mapId = String(mapRoot.dataset.googleMapId || "").trim();
          const firstPosition = sites[0].position;
          const mapOptions = {
            center: firstPosition,
            zoom: defaultZoom,
            clickableIcons: false,
            mapTypeControl: false,
            streetViewControl: false,
            fullscreenControl: true
          };
          if (mapId) mapOptions.mapId = mapId;

          const googleMap = new mapsApi.Map(canvas, mapOptions);
          const bounds = new mapsApi.LatLngBounds();
          const markerItems = [];

          sites.forEach(site => {
            const data = site.card.dataset;
            const title = [data.title, data.location].filter(Boolean).join(" - ");
            const markerOptions = {
              map: googleMap,
              position: site.position,
              title
            };
            let marker;
            let pin = null;

            if (mapId && mapsApi.marker && mapsApi.marker.AdvancedMarkerElement && mapsApi.marker.PinElement) {
              pin = new mapsApi.marker.PinElement({
                background: "#18a746",
                borderColor: "#18a746",
                glyphColor: "#ffffff",
                glyph: "T"
              });
              marker = new mapsApi.marker.AdvancedMarkerElement({
                map: googleMap,
                position: site.position,
                title,
                content: pin.element
              });
              marker.addListener("click", () => updateSelectedOpportunity(site.card));
            } else {
              marker = new mapsApi.Marker(markerOptions);
              marker.addListener("click", () => updateSelectedOpportunity(site.card));
            }

            markerItems.push({
              code: data.code,
              marker,
              pin,
              position: site.position
            });
            bounds.extend(site.position);
          });

          mapRoot.__tpowerGoogleMap = {
            map: googleMap,
            markers: markerItems
          };

          if (sites.length > 1) {
            googleMap.fitBounds(bounds, 56);
            mapsApi.event.addListenerOnce(googleMap, "idle", () => {
              if (googleMap.getZoom() > defaultZoom) googleMap.setZoom(defaultZoom);
            });
          }

          mapRoot.classList.add("live-map-ready");
          const activeCard = root.querySelector("[data-site-card].active") || sites[0].card;
          updateGoogleMapSelection(root, activeCard && activeCard.dataset.code);
        })
        .catch(() => {
          mapRoot.classList.remove("live-map-ready");
        });
    });
  }

  function positionOpportunityMarkers(scope) {
    const roots = Array.from((scope || document).querySelectorAll ? (scope || document).querySelectorAll("#opportunities") : []);
    if ((scope || document).matches && (scope || document).matches("#opportunities")) roots.unshift(scope || document);

    roots.forEach(root => {
      const markers = Array.from(root.querySelectorAll("[data-site-marker]"))
        .map(marker => ({
          marker,
          lat: parseMapCoordinate(marker.dataset.latitude),
          lng: parseMapCoordinate(marker.dataset.longitude)
        }))
        .filter(item => item.lat !== null && item.lng !== null);

      if (markers.length < 2) return;

      const latValues = markers.map(item => item.lat);
      const lngValues = markers.map(item => item.lng);
      const minLat = Math.min.apply(null, latValues);
      const maxLat = Math.max.apply(null, latValues);
      const minLng = Math.min.apply(null, lngValues);
      const maxLng = Math.max.apply(null, lngValues);
      const latRange = maxLat - minLat;
      const lngRange = maxLng - minLng;

      if (!latRange && !lngRange) return;

      markers.forEach(item => {
        const x = lngRange ? 8 + ((item.lng - minLng) / lngRange) * 84 : 50;
        const y = latRange ? 82 - ((item.lat - minLat) / latRange) * 70 : 47;
        item.marker.style.setProperty("--marker-x", clampMarkerPercent(x, 8, 92).toFixed(2) + "%");
        item.marker.style.setProperty("--marker-y", clampMarkerPercent(y, 12, 82).toFixed(2) + "%");
      });
    });
  }

  function updateSelectedOpportunity(card) {
    if (!card) return;
    const data = card.dataset;
    const root = card.closest("#opportunities") || document;

    root.querySelectorAll("[data-site-card]").forEach(item => {
      item.classList.toggle("active", item === card);
    });

    root.querySelectorAll("[data-site-marker]").forEach(marker => {
      marker.classList.toggle("active", marker.dataset.code === data.code);
    });
    updateGoogleMapSelection(root, data.code);
    syncMapLocationPanel(root, card);

    const textTargets = {
      "[data-detail-title]": data.title,
      "[data-detail-location]": data.location,
      "[data-detail-code]": data.code ? ((document.querySelector("[data-site-id-label]") && document.querySelector("[data-site-id-label]").dataset.siteIdLabel) || "Project ID:") + " " + data.code : "",
      "[data-detail-status]": data.status,
      "[data-detail-site-type]": data.siteType,
      "[data-detail-parking]": data.parking,
      "[data-detail-charger]": data.charger,
      "[data-detail-power]": data.power,
      "[data-detail-about]": data.about,
      "[data-selected-site]": data.title
    };

    Object.keys(textTargets).forEach(selector => {
      const node = document.querySelector(selector);
      if (node && textTargets[selector]) node.textContent = textTargets[selector];
    });

    setImage(document.querySelector("[data-detail-image]"), data.image);
    setImage(document.querySelector("[data-gallery-one]"), data.galleryOne);
    setImage(document.querySelector("[data-gallery-two]"), data.galleryTwo);
    setImage(document.querySelector("[data-gallery-three]"), data.galleryThree);

    const interestedSites = document.querySelector("[data-interested-sites]");
    if (interestedSites && data.title) {
      const menu = interestedSites.querySelector("[data-interested-sites-menu]");
      const option = menu && Array.from(menu.querySelectorAll("[data-interested-site-option]")).find(input => String(input.value || "").trim() === String(data.title || "").trim());
      if (option) option.checked = true;
      const titles = menu ? Array.from(menu.querySelectorAll("[data-interested-site-option]")).filter(input => input.checked).map(input => input.value) : [data.title];
      if (!titles.includes(data.title)) titles.unshift(data.title);
      setInterestSummary(titles);
    }
  }

  function normalizeFilterValue(value) {
    return String(value || "").trim().toLowerCase();
  }

  function isAllFilter(value, prefix) {
    const normalized = normalizeFilterValue(value);
    return !normalized || normalized.indexOf(prefix) === 0;
  }

  function searchableText(card) {
    const data = card.dataset;
    return [
      data.title,
      data.location,
      data.code,
      data.status,
      data.siteType,
      data.parking,
      data.charger,
      data.power,
      data.tags,
      data.about,
      data.latitude,
      data.longitude,
      card.innerText
    ].join(" ").toLowerCase();
  }

  function filterOpportunities(scope) {
    const root = scope.closest("#opportunities") || document;
    const searchInput = root.querySelector("[data-opportunity-search]");
    const statusSelect = root.querySelector("[data-opportunity-status]");
    const chargerSelect = root.querySelector("[data-opportunity-charger]");
    const empty = root.querySelector("[data-opportunity-empty]");
    const detail = root.querySelector(".detail-panel");
    const cards = Array.from(root.querySelectorAll("[data-site-card]"));
    if (!cards.length) return;

    const query = normalizeFilterValue(searchInput && searchInput.value);
    const status = normalizeFilterValue(statusSelect && statusSelect.value);
    const charger = normalizeFilterValue(chargerSelect && chargerSelect.value);
    let firstVisible = null;

    cards.forEach(card => {
      const haystack = searchableText(card);
      const statusText = normalizeFilterValue(card.dataset.status + " " + card.dataset.tags + " " + card.innerText);
      const chargerText = normalizeFilterValue(card.dataset.charger + " " + card.dataset.tags + " " + card.innerText);
      const matchesQuery = !query || haystack.indexOf(query) !== -1;
      const matchesStatus = isAllFilter(status, "all status") || statusText.indexOf(status) !== -1;
      const matchesCharger = isAllFilter(charger, "all charger") || chargerText.indexOf(charger) !== -1;
      const visible = matchesQuery && matchesStatus && matchesCharger;
      card.hidden = !visible;
      if (!visible) card.classList.remove("active");
      const marker = root.querySelector("[data-site-marker][data-code='" + CSS.escape(card.dataset.code || "") + "']");
      if (marker) {
        marker.hidden = !visible;
        if (!visible) marker.classList.remove("active");
      }
      if (visible && !firstVisible) firstVisible = card;
    });

    if (empty) empty.hidden = Boolean(firstVisible);
    if (detail) detail.hidden = !firstVisible;
    if (firstVisible) updateSelectedOpportunity(firstVisible);
  }

  function handleOpportunitySelection(event) {
    const siteCard = event.target.closest("[data-site-card]");
    if (siteCard) {
      updateSelectedOpportunity(siteCard);
      return true;
    }

    const siteMarker = event.target.closest("[data-site-marker]");
    if (siteMarker) {
      const root = siteMarker.closest("#opportunities") || document;
      const card = root.querySelector("[data-site-card][data-code='" + CSS.escape(siteMarker.dataset.code || "") + "']");
      if (card) updateSelectedOpportunity(card);
      return true;
    }

    const selectSite = event.target.closest("[data-select-site]");
    if (selectSite) {
      ensureInterestOptions();
      const activeCard = document.querySelector("[data-site-card].active") || document.querySelector("[data-site-card]");
      updateSelectedOpportunity(activeCard);
      return true;
    }

    return false;
  }

  document.addEventListener("input", event => {
    const field = event.target.closest("input, select, textarea");
    if (!field) return;
    setFieldError(field, "");
    updatePlaceholderSelect(field);
    if (field.matches("[data-address-input]")) scheduleAddressLocate(field);
    const form = field.closest("form");
    const status = form && form.querySelector(".form-status");
    if (status) status.className = "form-status";
    if (field.matches("[data-opportunity-search]")) filterOpportunities(field);
  });

  document.addEventListener("change", event => {
    const field = event.target.closest("input, select, textarea");
    if (field) {
      setFieldError(field, "");
      updatePlaceholderSelect(field);
    }

    const interestedOption = event.target.closest("[data-interested-site-option]");
    if (interestedOption) {
      const interestedSites = interestedOption.closest("[data-interested-sites]");
      if (!interestedSites) return;
      const titles = Array.from(interestedSites.querySelectorAll("[data-interested-site-option]"))
        .filter(input => input.checked)
        .map(input => input.value);
      setInterestSummary(titles);
      return;
    }
  });

  document.addEventListener("pointerdown", event => {
    handleOpportunitySelection(event);
  }, true);

  document.addEventListener("click", event => {
    const modalClose = event.target.closest("[data-success-modal-close]");
    if (modalClose) {
      closeSuccessModal(modalClose.closest("[data-success-modal]"));
      return;
    }

    if (handleOpportunitySelection(event)) return;

    const currentLocationButton = event.target.closest("[data-use-current-location]");
    if (currentLocationButton) useCurrentLocation(currentLocationButton);
  });

  document.addEventListener("change", event => {
    const placeholderSelect = event.target.closest("[data-placeholder-select]");
    if (placeholderSelect) updatePlaceholderSelect(placeholderSelect);

    const opportunityFilter = event.target.closest("[data-opportunity-status], [data-opportunity-charger]");
    if (opportunityFilter) filterOpportunities(opportunityFilter);

    const upload = event.target.closest("input[type='file']");
    if (upload) updateUploadCard(upload);
  });

  document.addEventListener("submit", event => {
    const form = event.target.closest("[data-lead-form]");
    if (!form) return;
    event.preventDefault();

    if (form.dataset.submitted === "true") {
      const existingRef = form.dataset.submittedRef || reference(form.dataset.refPrefix || "TP");
      const label = form.dataset.successLabel || "request";
      showSuccessModal(form, existingRef, label);
      return;
    }

    if (!validateForm(form)) {
      showStatus(form, "error", "Please fix the highlighted fields before submitting.");
      return;
    }

    const ref = reference(form.dataset.refPrefix || "TP");
    const label = form.dataset.successLabel || "request";
    showStatus(
      form,
      "success",
      "<strong>Submitted successfully.</strong><br>Reference: <strong>" + ref + "</strong><br>T-Power will review this " + label + " and follow up using the contact details provided."
    );
    showSuccessModal(form, ref, label);
    if (form.dataset.formType === "host-site") updateHostStatus(ref);
    lockSubmittedForm(form, ref);
  });

  document.addEventListener("keydown", event => {
    if (event.key !== "Escape") return;
    const modal = document.querySelector("[data-success-modal]");
    if (modal) closeSuccessModal(modal);
  });

  document.addEventListener("shopify:block:select", event => {
    const siteCard = event.target && event.target.closest && event.target.closest("[data-site-card]");
    if (siteCard) updateSelectedOpportunity(siteCard);
  });

  document.querySelectorAll("[data-placeholder-select]").forEach(updatePlaceholderSelect);
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", syncInterestSection, { once: true });
  } else {
    syncInterestSection();
  }
  document.addEventListener("shopify:section:load", syncInterestSection);
})();
